import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { StoreModule } from '@ngrx/store';

import { UiComponentsModule, ModalModule } from '@fcom/ui-components';
import { UiTranslateModule } from '@fcom/ui-translate';
import { PipesModule } from '@fcom/common';
import { DirectiveModule } from '@fcom/common/directives/directive.module';
import { FinFormsModule } from '@fcom/common/forms';
import { ComponentsModule } from '@fcom/common/components/components.module';
import { LoginModule } from '@fcom/common/login';

import { BookingWidgetGtmService } from './services/booking-widget-gtm.service';
import { BOOKING_WIDGET_FEATURE_KEY } from './store/constants';
import { BookingWidgetCalendarService } from './services/booking-widget-calendar.service';
import {
  AirCalendarComponent,
  BookingWidgetComponent,
  BookingWidgetSelectorComponent,
  LocationSelectorComponent,
  PaxAmountSelectorComponent,
  TravelDatesSelectorComponent,
  TripTypeSelectorComponent,
  DiscountCodeComponent,
  BookingWidgetNotificationComponent,
  PreviousSearchesComponent,
} from './components';
import { bookingWidgetReducer } from './store/reducers/booking-widget.reducer';

@NgModule({
  imports: [
    CommonModule,
    PipesModule,
    UiComponentsModule,
    UiTranslateModule,
    DirectiveModule,
    ModalModule,
    FinFormsModule,
    ComponentsModule,
    LoginModule,
    StoreModule.forFeature(BOOKING_WIDGET_FEATURE_KEY, bookingWidgetReducer),
  ],
  providers: [BookingWidgetCalendarService, BookingWidgetGtmService],
  declarations: [
    AirCalendarComponent,
    BookingWidgetComponent,
    BookingWidgetSelectorComponent,
    PaxAmountSelectorComponent,
    LocationSelectorComponent,
    PreviousSearchesComponent,
    TripTypeSelectorComponent,
    TravelDatesSelectorComponent,
    DiscountCodeComponent,
    BookingWidgetNotificationComponent,
  ],
  exports: [BookingWidgetComponent, BookingWidgetSelectorComponent],
})
export class BookingWidgetModule {}
